import{createContext as l}from"react";const e=l({appId:null,apiKey:null}),t=l([{query:"",index:null,initialSearchProps:null},()=>{}]);export{t as AlgoliaQueryContext,e as AlgoliaSearchContext};
//# sourceMappingURL=contexts.js.map
